// Certificates api
export const CERTIFICATES_LIST_ENDPOINT = '/api/certificates/certificates-grid-view';
export const CERTIFICATES_LIST_ENDPOINT_FAVORITE = '/api/certificates/certificates-grid-view-favorite';

export const CERTIFICATE_FULL_VIEW_ENDPOINT = '/api/certificates/certificate-full-view'; // ?Id={id}
export const CERTIFICATE_SHORT_DETAIL_ENDPOINT = '/api/certificates/certificate-short-detail-view'; // ?Id={id}
export const CERTIFICATE_ASSOCIATION_GRID = '/api/certificates/certificate-association-grid';
export const CERTIFICATE_DETAIL_GRID = '/api/certificates/certificate-detail-grid';
export const CERTIFICATE_CREATE_ENDPOINT = '/api/certificates/create-certificate';
export const CERTIFICATE_UPDATE_ENDPOINT = '/api/certificates/update-certificate';
export const CERTIFICATE_DELETE_ENDPOINT = '/api/certificates/delete-certificate'; // /{id}